import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class ProjectPreorderAPI {
    public static async getById(id: string) {
        let response;
        try {
            response = (await ApiController.get(ApiRoutes.projectPreorder.getById(id))) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return response?.data ?? null;
    }

    public static async delete(id: string) {
        try {
            await ApiController.delete(ApiRoutes.projectPreorder.delete(id));
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve();
    }

    public static async release(id: string, removedAttachmentIds: string[] = []) {
        try {
            await ApiController.post(ApiRoutes.projectPreorder.release(id), { removedAttachmentIds });
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve();
    }

    public static async getPendingList() {
        let response;
        try {
            response = (await ApiController.get(ApiRoutes.projectPreorder.pendingList)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return response?.data ?? [];
    }

    public static async getPendingCount(): Promise<number> {
        let response;
        try {
            response = (await ApiController.get(ApiRoutes.projectPreorder.pendingCount)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return response?.data?.count ?? 0;
    }
    
    public static async createNew(
        projectId: string,
        comment: string | null,
        options?: {
            hasPositions?: boolean;
            desiredDeliveryDate?: string | null;
            positions?: { key?: string; system: string; quantity: number }[];
            projectConnection?: string | null;
            draftId?: number | string | null;
            existingAttachmentIds?: string[];
            attachmentType?: string | null;
        }
    ) {
        const request = {
            data: {
                type: 'project_preorders',
                attributes: {
                    comment,
                    hasPositions: options?.hasPositions ?? false,
                    ...(options?.desiredDeliveryDate ? { desiredDeliveryDate: options.desiredDeliveryDate } : {}),
                    ...(options?.positions && options.positions.length > 0 ? { positions: options.positions } : {}),
                    ...(options?.projectConnection ? { projectConnection: options.projectConnection } : {}),
                    ...(options?.draftId ? { draftId: options.draftId } : {}),
                    ...(options?.existingAttachmentIds && options.existingAttachmentIds.length > 0
                    ? { existingAttachmentIds: options.existingAttachmentIds }
                    : {}),
                    ...(options?.attachmentType ? { attachmentType: options.attachmentType } : {}),
                },
                relationships: {
                    project: {
                        data: {
                            type: 'projects',
                            id: projectId,
                        },
                    },
                },
            },
        };

        let preorder;
        try {
            preorder = (await ApiController.post(ApiRoutes.projectPreorder.create, request)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(preorder);
    }
}